import React from 'react';
import { AcvtPromotion } from '../../../../types/acvt';
import style from './style.module.scss';

type SmallPromoCard = {
    promoObject: AcvtPromotion;
    opened: React.Dispatch<
        React.SetStateAction<{
            homePromoCard: boolean;
            homeGameCard: boolean;
            promoCard: boolean;
            gameCard: boolean;
        }>
    >;
    setSinglePromo: (promo: AcvtPromotion) => void;
};

const ArrowIcon = () => (
    <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M1.875 6H10.125"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.75 2.625L10.125 6L6.75 9.375"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

/**
 * Small coupon card shown in the home page Coupons / In Store rows.
 * Mirrors the Figma "Coupon" component (file
 * HfdrKMPuxRduN2Tx38kLsR, node 3783-293006):
 *
 *   - colored "image background" zone with the product image centered
 *     inside (background color comes from the promotion)
 *   - tag-shaped red price sticker pinned to the top edge
 *   - category / title / description rows below the image
 *   - circular red CTA with a white halo straddling the image / text
 *     boundary
 */
export const AcvtSmallPromoCard = ({
    promoObject,
    opened,
    setSinglePromo,
}: SmallPromoCard) => {
    const hasPromoOfferTitle = (() => {
        const title = promoObject?.promotionalOffer?.title;
        if (typeof title !== 'string') {
            return false;
        }
        const normalized = title.trim();
        return normalized.length > 0 && normalized !== 'undefined';
    })();

    const openDetail = () => {
        setSinglePromo(promoObject);
        opened((prevState) => ({ ...prevState, homePromoCard: true }));
    };

    return (
        <button type="button" className={style.card} onClick={openDetail}>
            <div
                className={style.image_zone}
                style={{
                    backgroundColor:
                        promoObject?.backgroundColor ?? 'var(--Neutral-4)',
                }}
            >
                <img
                    alt=""
                    className={style.image}
                    src={promoObject.thumbnail ?? ''}
                />
            </div>
            <div className={style.text}>
                {promoObject.category?.title && (
                    <span className={style.category}>
                        {promoObject.category.title}
                    </span>
                )}
                <span className={style.title}>{promoObject.title}</span>
                {promoObject.subTitle && (
                    <span className={style.subtitle}>
                        {promoObject.subTitle}
                    </span>
                )}
            </div>
            {promoObject.type === 'coupon' && hasPromoOfferTitle && (
                <span className={style.sticker}>
                    {promoObject.promotionalOffer?.title}
                </span>
            )}
            <span className={style.cta} aria-hidden>
                <ArrowIcon />
            </span>
        </button>
    );
};
